import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=ffc3fb90&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
import style1 from "./Breadcrumb.vue?vue&type=style&index=1&id=ffc3fb90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc3fb90",
  null
  
)

export default component.exports